import { formatCountdown, cn } from '../../utils'
import { useMemo } from 'react'

function CueItemElapsed ({ className, overtimeClassName, moment }) {
  const overtime = moment && moment.left <= 0

  const Countdown = useMemo(() => {
    if (!moment?.countdown) return null

    return formatCountdown(moment.countdown)
  }, [moment])

  if (!moment?.countdown) {
    return (
      <div className={cn('px-2', className)}>
        <span className="opacity-50">--:--</span>
      </div>
    )
  }

  return (
    <div
      className={cn(
        'px-2',
        overtime ? 'bg-gray-900 rounded-sm text-red-500' : 'text-white',
        overtime && overtimeClassName,
        className,
      )}
    >
      {overtime && '+'}
      {Countdown}
    </div>
  )
}

export default CueItemElapsed